import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVideoOff = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		stroke: "none",
		strokeWidth: 1,
		fill: "var(--main-color)",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsxs("g", {
			fillRule: "nonzero",
			children: [/* @__PURE__ */ _jsx("path", { d: "M17 15.59l-2-2L8.41 7l-2-2-1.7-1.71a1.004 1.004 0 10-1.42 1.42l.54.53L5.59 7l9.34 9.34 1.46 1.46 2.9 2.91a1 1 0 001.42 0 1 1 0 000-1.42L17 15.59zM14 17H5a1 1 0 01-1-1V8a1 1 0 01.4-.78L3 5.8A3 3 0 002 8v8a3 3 0 003 3h9a2.94 2.94 0 001.66-.51L14.14 17a.7.7 0 01-.14 0z" }), /* @__PURE__ */ _jsx("path", { d: "M21 7.15a1.7 1.7 0 00-1.85.3l-2.15 2V8a3 3 0 00-3-3H7.83l2 2H14a1 1 0 011 1v4.17l4.72 4.72a1.68 1.68 0 001.29-.04 1.6 1.6 0 001-1.48V8.63A1.6 1.6 0 0021 7.15zm-1 7.45L17.19 12 20 9.4v5.2z" })]
		})
	})
});
export { SvgVideoOff as ReactComponent };
